<template>
    <section class="question" id="questionTop">
        <question-tag
            :correctRate="question.correctRate"
            :avgSolveTime="question.avgSolveTime"
            :level="paperLevel"
        ></question-tag>

        <div class="pda-default">

            <div class="single" v-if="groupQuestionCount === 1">
                <div class="t-subtitle5 question-title">
                    {{ question.contents.text }}
                    <img :src="question.contents.image" alt="" v-if="question.contents.image" class="mgt-16 independent-img-video-bd-radius">
                </div>
                <div class="question-choices">
                    <div class="t-body1 choice" v-for="(choice, index) in question.choices" :key="index" 
                        :class="{'correct': choice.correct === true, 'incorrect': choice.correct === false && choice.selected === true}">
                        <div class="d-flex justify-content-between align-items-center mgl-8 mgr-8 pdt-5 pdb-5">
                            <div class="correct-icon mgl-8 mgr-8" v-if="choice.correct === true"></div>
                            <div class="incorrect-icon mgl-8 mgr-8" v-if="choice.correct === false && choice.selected === true"></div>
                            <div class="number-circle mgl-8 mgr-8" v-if="choice.correct === false && choice.selected === false">{{index+1}}</div>

                            <div class="flex-grow-1 mgl-8 mgr-8">
                                {{ choice.contents }}
                            </div>

                            <div class="t-headline9 mgl-8 mgr-8 rate word-break-normal" v-if="choice.selectionRatio">
                                {{parseInt(choice.selectionRatio)}}%
                            </div>
                        </div>
                        <div class="mgt-11 mgb-10 mgl-16 mgr-16 independent-img-video-bd-radius" v-if="choice.image">
                            <img :src="choice.image" alt="">
                        </div>
                    </div>
                </div>

            </div>


            <div class="group mgb-30" v-else>
                <div class="bottom-card1">
                    <div class="mdc-card mdc-elevation--z2 bottom-card1-1 bg-documentGray"></div>
                </div>
                <div class="bottom-card2">
                    <div class="mdc-card mdc-elevation--z1 bottom-card2-1 bg-documentGray"></div>
                </div>
                
                <div class="t-subtitle5">
                    {{groupQuestionTitle}}
                </div>

                <div class="mdc-card mdc-elevation--z3 pda-default mgt-16 bg-documentGray">

                    <div class="t-headline14">
                        {{ question.contents.text }}
                    </div>
                    <div class="mgt-16 independent-img-video-bd-radius" v-if="question.contents.image">
                        <img :src="question.contents.image" alt="">
                    </div>
                    <div class="question-choices">
                        <div class="t-body1 choice" v-for="(choice, index) in question.choices" :key="index" 
                            :class="{'correct': choice.correct === true, 'incorrect': choice.correct === false && choice.selected === true}">
                            <div class="d-flex justify-content-between align-items-center mgl-8 mgr-8 pdt-5 pdb-5">
                                <div class="correct-icon mgl-8 mgr-8" v-if="choice.correct === true"></div>
                                <div class="incorrect-icon mgl-8 mgr-8" v-if="choice.correct === false && choice.selected === true"></div>
                                <div class="number-circle mgl-8 mgr-8" v-if="choice.correct === false && choice.selected === false">{{index+1}}</div>

                                <div class="flex-grow-1 mgl-8 mgr-8">
                                    {{ choice.contents }}
                                </div>

                                <div class="t-headline9 mgl-8 mgr-8 rate word-break-normal" v-if="choice.selectionRatio">
                                    {{parseInt(choice.selectionRatio)}}%
                                </div>
                            </div>
                            <div class="mgt-11 mgb-10 mgl-16 mgr-16 independent-img-video-bd-radius" v-if="choice.image">
                                <img :src="choice.image" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            
            </div>

            <div class="h-1"></div>
            
            <question-tip v-if="question.tip" :tip="question.tip"/>
        </div>



        <question-feedback
            :commonFeedback="question.feedback.common"
            :correctFeedback="question.feedback.correct"
            :incorrectFeedback="question.feedback.incorrect"
            :videoFeedback="question.feedback.video"
            :feedbackStatus="feedback"
            :correct="question.correct"
            :questionId="question.questionId"
        ></question-feedback>
    </section>


</template>

<script>
/**
 * 단일답안 문항 피드백 컴포넌트(choice single type question  feedback component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import QuestionTag from './QuestionTag.vue'
import QuestionTip from './QuestionTip.vue'
import QuestionFeedback from './QuestionFeedback.vue'
import {questionMixin} from '@/mixins/question.js'

export default {
    props: ['question', 'groupQuestionCount', 'groupQuestionTitle', 'paperLevel', 'feedback'],
    data() {
        return {
        }
    },
    components: {
        'question-tag': QuestionTag,
        'question-tip': QuestionTip,
        'question-feedback': QuestionFeedback
    },

    mixins: [questionMixin],
}
</script>
<style scoped>
.question-choices .choice .correct-icon {
    min-width: 32px;
    height: 32px;}
</style>